// src/pages/ledger/ledgerUtils.js
const KEY = "ledger-print-cache";
const TTL = 10 * 60 * 1000; // ۱۰ دقیقه

/* چون چاپ در تب جدید باز می‌شود، state ری‌اکت share نمی‌شود؛ از localStorage استفاده می‌کنیم */
export const saveLedgerCache = (payload) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...payload, ts: Date.now() }));
  } catch (e) {
    /* ignore */
  }
};

export const readLedgerCache = (customerId) => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (
      c &&
      String(c.customerId) === String(customerId) &&
      Date.now() - c.ts < TTL
    ) {
      return c;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
};

export const FILTER_LABELS = {
  all: "فاکتور و تراکنش",
  factor: "فاکتور",
  transaction: "تراکنش",
};

/* raw = پاسخ کامل سرور (بدون فیلتر تاریخ). فیلتر نوع + بازه تاریخ + مانده تجمعی اینجا محاسبه می‌شود */
export function computeLedger(
  raw,
  { from = "", to = "", filter = "all" } = {},
) {
  const entries = (raw.rows || []).filter(
    (r) => filter === "all" || r.kind === filter,
  );

  let running = 0;
  let opening = 0;
  const rows = [];

  entries.forEach((e) => {
    const net = (Number(e.debit) || 0) - (Number(e.credit) || 0);
    running += net;

    if (from && e.date < from) {
      opening = running;
      return;
    }
    if (to && e.date > to) return;
    rows.push({ ...e, balance: running });
  });

  const totalDebit = rows.reduce((s, r) => s + (Number(r.debit) || 0), 0);
  const totalCredit = rows.reduce((s, r) => s + (Number(r.credit) || 0), 0);

  return {
    customer: raw.customer,
    opening,
    rows,
    totalDebit,
    totalCredit,
    closing: rows.length ? rows[rows.length - 1].balance : opening,
  };
}
